//Foundation 6
//Foundation.Abide.defaults.patterns['password'] = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/;
Foundation.Abide.defaults.patterns['entero'] = /^[0-9]*$/;
Foundation.Abide.defaults.patterns['importe'] = /^[-]?\d+([,]\d+)?$/;
Foundation.Abide.defaults.patterns['hora'] = /^[0-2][0-9]:[0-5][0-9]$/;
Foundation.Abide.defaults.patterns['horas'] = /^[0-9]?[0-9](\:[0-5][0-9])?$/;
Foundation.Abide.defaults.patterns['friendly_url'] = /^[0-9a-zA-Z\-_]*$/;
Foundation.Abide.defaults.patterns['dia_mes'] = /^(3[01])|([0-2][0-9])|([0-9])$/;
Foundation.Abide.defaults.patterns['email_list'] = /^(([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+);?)*$/;
Foundation.Abide.defaults.patterns['venue_acronym'] = /^.{3,3}$/;
Foundation.Abide.defaults.patterns['character'] = /^$/;
Foundation.Abide.defaults.patterns['only_letters'] = /^[a-zA-Z]+$/;
Foundation.Abide.defaults.patterns['phone_number'] = /^(\+\d{1,3})?([\(]\d{0,15}[\)])?([0-9\-\ ]{0,25})$/; // telefono???
Foundation.Abide.defaults.patterns['ip_address'] = /^([0-9]{1,3}\.){3}[0-9]{1,3}$/;  // dir ip???
Foundation.Abide.defaults.patterns['domain_url'] = /^(([a-zA-Z0-9]([a-zA-Z0-9\-\.]*[a-zA-Z0-9])?)+[a-zA-Z]+)(\/[a-zA-Z0-9]([a-zA-Z0-9\-\.]*[a-zA-Z0-9])?)*$/;
Foundation.Abide.defaults.patterns['submitter'] = /^[0-9A-Za-z]*$/;

window.MAX_CSV_FILE_SIZE = 2097152;

Foundation.Abide.defaults.validators['max_file_size'] =
	function ($el, required, parent) {
		if ($el[0].files.length == 0) {
			window.loadNotification([polyglot.t("global.Choose_a_file")], 'error', 0);
		}
		else if ($el[0].files[0].size > MAX_CSV_FILE_SIZE) {
			window.loadNotification([polyglot.t("promotions.csv_file.error.max_size")], 'error', 0);
			$el[0].value = "";
		}
	};
//========================= TOOLTIPS ==========================

/**
* Regenera los tooltips para los elementos dinámicos (tablas)
* @returns
*/
$('table').on('draw.dt', function () {
	window.refrescarTooltip();
});

/**
* Regenera los tooltips para los elementos dinámicos
* @returns
*/
window.refrescarTooltip = function () {
	Tipped.create('.dynamic-tooltip',
		{
			maxWidth: 200,
			hideOnClickOutside: true,
			hideOthers: true,
			hideOn: {
				element: 'mouseleave',
				tooltip: 'mouseenter'
			}
		});
}



//* ================ VALIDADOR DE TABS ================ */
window.ValidadorTabs = function (idContenedor, onValid) {
	this.idContenedor = idContenedor;
	this.onValid = onValid;
	this.tabs = [];

	const tabsFormulario = $("#" + this.idContenedor + " .form-inside ");
	let tabFormulario;

	for (let i = 0; i < tabsFormulario.length; i++) {
		tabFormulario = tabsFormulario[i];
		this.tabs[i] = new Object();
		this.tabs[i].id = tabFormulario.id;
		this.tabs[i].validado = false;

		$(tabFormulario).find("form").on("submit", function (ev) {
				ev.preventDefault();
			});
	}
}

window.ValidadorTabs.prototype.validar = function (idTab) {
	//Primero validamos el tab actual
	$('.radio-tab').each(function (i) {
		if ($(this).prop('checked')) {
			idTab = $(this).val();
		}
	});

	//Si es válido se valida el resto
	if (window.validarTab(idTab)) {
		let allTabsValid = true;
		let idNextTab;

		for (let i in this.tabs) {
			idNextTab = this.tabs[i].id;

			//Si encuentra un tab no válido, lo lanza
			if (idNextTab != idTab && !window.validarTab(idNextTab)) {
				allTabsValid = false;
				$('.radio-tab').each(function () {
					if ($(this).val() == idNextTab) {
						$(this).prop("checked", true);
					}
				});
				break;
			}
		}

		if (allTabsValid) {
			this.onValid();
		}
	}
}

window.ValidadorTabs.prototype.reset = function () {
	let tab;
	let form;

	for (let i in this.tabs) {
		tab = this.tabs[i];
		form = $("#" + tab.id + " form");

		if (form.length == 0) {
			continue;
		}

		form[0].reset();
		form.find("input").val("");
		form.find("input[type=checkbox]").prop('checked', false);

	}
}

window.validarTab = function (idTab) {
	if ($("#" + idTab + " form").length) {
		$("#" + idTab + " form").foundation("validateForm", valid);
	}

	let valid = true;

	const eachFn = function(i) {
		if ($(this).prop("class").indexOf("is-invalid-input") > -1) {
			valid = false;
		}
	}

	$("#" + idTab + " form input").each(eachFn);
	$("#" + idTab + " form select").each(eachFn);

	return valid;
}

window.isSmall = function () {
	return Foundation.MediaQuery.current != null && Foundation.MediaQuery.current == "small";
}

window.isMedium = function () {
	return Foundation.MediaQuery.current != null && Foundation.MediaQuery.current == "medium";
}

/**
 * Cierra la venta de espera.
 */
window.cerrarVentanaEspera = function (cerrarVentanaSup) {
	if (ventanaEsperaAjaxOn) {
		if (cerrarVentanaSup) {
			$("#" + idVentanaSupEspera).foundation('close'); //.foundation('reveal','close');
		}

		ventanaSupEspera = null;
	}
}
